import { fromJS, setIn } from "immutable";
import _ from "lodash";
import { title } from "./Components/Step2LegacyOptions/title";
import { DataFormatter } from "./Components/Data/Fotmatter";
import { filterCountryDesc } from "./Components/Data/DropDownData";
import apiDataFormatter from "./Components/Step1Setup/Components/DataFormatter";
import Constants from "./constants";
import * as actionNameTypes from "./actionType";
import { getUserEditDetailsType } from '../../actions/globalActionTypes'
import { getPrimaryAccount } from "../../utils/sessionUtil";

const baseOption = {
  optionName: "",
  optionId: 1,
  assignedPercentage: 0,
  selected: false,
  hasChange: false,
  successorAdvisor: null,
  successionPlanGranteeOrg: null
};
const baseAddress = {
  line1: "",
  line2: "",
  line3: "",
  state: "",
  city: "",
  zip: "",
  country: "0"
};
const baseSuccesorAdvisor = {
  key: "1",
  title: "",
  firstName: "",
  middleName: "",
  lastName: "",
  suffix: "",
  relationshipType: "",
  dob: "",
  preferedPhone: "",
  preferedEmail: "",
  address: baseAddress
};
const baseSuccessionPlan = {
  key: "1",
  title: "",
  name: "",
  contactFirstName: "",
  contactLastName: "",
  contactPhone: null,
  contactEmail: "",
  ein: null,
  address: baseAddress
};

const initLegacyValues = {
  [Constants.APPOINT_INDIVIDUAL]: {
    ...baseOption, ...{optionId: 1, optionName: "Pass account privileges to successor-advisors", successorAdvisor: [{...baseSuccesorAdvisor}]}
  },
  [Constants.CREATE_ACCOUNT]: {
    ...baseOption, ...{optionId: 2, optionName: "Create new accounts with successor-advisors", successorAdvisor: [{...baseSuccesorAdvisor}]}
  },
  [Constants.PHILAN_FUND]: {
    ...baseOption, ...{optionId: 3, optionName: "Transfer assets to the Philanthropic Impact Fund" }
  },
  [Constants.MULTI_CHARITY]: {
    ...baseOption, ...{optionId: 4, optionName: "Recommend a final grant to charity", successionPlanGranteeOrg: [{...baseSuccessionPlan}]}
  },
  [Constants.ANNUAL_GRANT]: {
    ...baseOption, ...{optionId: 5, optionName: "Establish an Endowed Grant Plan" }
  },
  [Constants.OTHERS]: {
    ...baseOption, ...{optionId: 6, optionName: "Other"}
  }
};

const initialState = fromJS({
  loggedUser: "",
  isPostInviteError:false,
  isUserLoading: true,
  accountData: {
    isLoading: true,
    designatedUpdateLoader: false,
    data: {},
    error: "",
    show504Error:false
  },
  resetData: {
    isLoading: true,
    data: {},
    error: ""
  },
  profileData: {
    isLoading: true,
    data: {},
    error: ""
  },
  defaultFundName: "",
  primaryAccount: [],
  toUpdate: true,
  toChangeName: true,
  toChangePrimary: true,
  updateDone: true,
  savedBlur: "",
  addDesignated: [],
  accessKeyData: "",
  incorrectResponseCount: 0,
  correctResponseCount: 0,
  incorrectQuesResponseCount: 0,
  correctQuesResponseCount: 0,
  updateUserIdData:"",
  useridExists:"",
  passData: false,
  changeDefault: 0,
  submitEditAdvisorError:{},
  updateresendEmailFailed: false,

  /********************************************** STATE FOR ADVISOR & SUCCESSION *********************************************/

  webAccessInfo: {
    fundName: "",
    userId: ""
  },
  editAdvisorAPIData: { data: {} },
  formattedAPIData: { data: {} },
  primaryAdvisor: {
    email: {},
    phone: {},
    addresses: {},
    relatedDonor: {},
    info: {},
    reset: false,
    disable: false,
    role: { role: {} },
    userId: { userId: "" },
    deletedAddress :[]
  },
  secondaryAdvisor: {
    email: {},
    phone: {},
    addresses: {},
    relatedDonor: {},
    info: {},
    reset: false,
    role: {},
    userId: {},
    deletedAddress :[]
  },
  dropdownValues: {
    isLoading: true,
    data: {},
    error: ""
  },
  relationshipValues: {
    isLoading: true,
    data: {},
    error: ""
  },
  advisorCount: {
    count: 1,
    createCount: 1,
    charityCount: 1
  },
  fundName: {},
  error: {},
  zipCode: {data: []},
  //legacyOptions: {},
  showRemainingPercentage: {},
  shouldClose: {},
  duplicateAdvisorInfo: false,
  isSecondaryAdvisor: {},
  isNewSecondaryAdd: {},
  showMore: {},
  isStep1Edit: {},
  finalJSON: {},
  estimatedInitialContribution: {},
  shouldEmptyZip: {},
  tempJSON: {},
  isDataChanged: { changed: false },
  successionPlan: {
    data: [],
    isLoading: true
  },
  legacyValues: {},
  testing: { isUpdated: false },
  checkChange: [],
  hasChange: false,
  updateSuccession: false,
  othersExist: false,
  policies: [],
  endowed: [],
  titleValues: [],  
  apiFlag: false,
  myAccountMandatoryMissingFlag: false,
  legacyFormValid:{
    multiCharity: false,
    appointInd: false,
    createAcc:false
  },
  errorVariable: false,
  apiIndicator: false
});

const myAccount = (state = initialState, action) => {
  switch (action.type) {
    case "GET_PROFILE_NAME_LOADING":
      return state.setIn(["isUserLoading"], true);
    case actionNameTypes.designatedDataLoaderType:
      return state.setIn(["accountData", "designatedUpdateLoader"], true);
    case "GET_PROFILE_NAME_SUCCESS":
      return state
        .setIn(["loggedUser"], action.payload)
        .setIn(["isUserLoading"], false);
    case actionNameTypes.handle504Error:
      return state.setIn(["accountData","show504Error"],action?.error?.response?.status === 504);
    case actionNameTypes.hide504Error:
      return state.setIn(["accountData","show504Error"],false);
    case actionNameTypes.myAccDataType:      
      return state
        .setIn(["accountData", "data"], action.payload)
        .setIn(["resetData", "data"], action.payload)
        .setIn(["defaultFundName"], action.payload.fundName)
        .setIn(["primaryAccount"], action.payload.primaryAccountContact)
        .setIn(["accountData", "isLoading"], false)
        .setIn(["resetData", "isLoading"], false);

    case actionNameTypes.fetchMyAccDataLoaderType:
      return state.setIn(["accountData", "isLoading"], true);

    case actionNameTypes.designatedDataSuccType:
      return state
        .setIn(["accountData", "data", "designatedParties"], action.payload)
        .setIn(["toUpdate"], !state.getIn(["toUpdate"]))
        .setIn(["accountData", "designatedUpdateLoader"], false)
        .setIn(["savedBlur"], "Blur");

    case actionNameTypes.designatedDataFailureType:
      return state
        .setIn(["accountData", "data", "designatedParties"], action.payload)
        .setIn(["toUpdate"], !state.getIn(["toUpdate"]))
        .setIn(["accountData", "designatedUpdateLoader"], false)
        .setIn(["savedBlur"], "Blur");

    case actionNameTypes.resetDesignatedDataType:
      return state.setIn(
        ["accountData", "data", "designatedAccess"],
        state.getIn(["resetData", "data", "designatedAccess"])
      );

      case actionNameTypes.hideComponentType:
      return state
        .setIn(["toUpdate"], true)
       
    case actionNameTypes.showComponentType:
      return state
        .setIn(["toUpdate"], !state.getIn(["toUpdate"]))
        .setIn(["savedBlur"], "Blur");

    case actionNameTypes.myProfileDetails:
      return state
        .setIn(["profileData", "data"], action.payload)
        .setIn(
          ["profileData", "isLoading"],
          false
        );
    case actionNameTypes.tabaleDataSuccessType:
      return state
        .setIn(
          ["profileData", "data", "accountInformation"],
          action.payload.data
        )
        .setIn(["toUpdate"], !state.getIn(["toUpdate"]));

    case actionNameTypes.changeNameType:
      return state
        .setIn(["toChangeName"], !state.getIn(["toChangeName"]))
        .setIn(["savedBlur"], "Blur");

    case actionNameTypes.saveNewFundNameSuccessType:
      return state
        .setIn(["defaultFundName"], action.payload)
        .setIn(["accountData", "data","fundName"], action.payload)
        // .setIn(["toChangeName"], !state.getIn(["toChangeName"]));

    case actionNameTypes.newFundNameToSaveType:
      return state
        .setIn(["defaultFundName"], action.payload)
        .setIn(["toChangeName"], !state.getIn(["toChangeName"]));

    case actionNameTypes.changePrimaryType:
      return state
        .setIn(["toChangePrimary"], !state.getIn(["toChangePrimary"]))
        .setIn(["savedBlur"], "Blur");

    case actionNameTypes.primaryContactSuccessType:
      return state      
      .setIn(["toChangePrimary"], !state.getIn(["toChangePrimary"]));
    
    case actionNameTypes.myAccDataSuccessType:
      return state.setIn(["accountData", "data"], action.payload);

    case actionNameTypes.primaryContactLoadingType:
      return state
      .setIn(["updateDone"],false); 
    case actionNameTypes.primaryContactMyAccSuccessType:
      return state
      .setIn(["updateDone"], true);
    case actionNameTypes.primaryContactFailedType:
        return state
        .setIn(["updateDone"], true);
    case "ADD_DESIGNATED_SUCCESS":
      return state.setIn(["addDesignated"], action.payload);

    /********************************************** REDUCER FOR ADVISOR & SUCCESSION *********************************************/

    case actionNameTypes.prefilPrimaryValType:
      return state.setIn(["primaryAdvisor", "email"], action.payload);

    case actionNameTypes.prefilSecValuesType:
      return state.setIn(["secondaryAdvisor", "email"], action.payload);

    case actionNameTypes.emailChangeHandlerType:
      var obj = Object.keys(action.payload);
      return state
        .setIn([obj[0], "email"], action.payload[obj[0]])
        .setIn(["isDataChanged", "changed"], true);

    case actionNameTypes.resetFormEmailType:
      var obj = Object.keys(action.payload);
      return state
        .setIn([obj[0], "email"], action.payload[obj[0]])
        .setIn([obj[0], "info", "title"], "")
        .setIn([obj[0], "info", "suffix"], "")
        .setIn([obj[0], "info", "gender"], "")
        .setIn([obj[0], "info", "ssn"], "")
        .setIn([obj[0], "info", "confirmSSN"], "")
        .setIn(["isDataChanged", "changed"], true);

    case actionNameTypes.resetFormContributorType:
      var obj = Object.keys(action.payload);
      return state.setIn([obj[0], "relatedDonor"], action.payload[obj[0]]);

    case actionNameTypes.prefilPrimaryAddrValType:
      return state.setIn(["primaryAdvisor", "addresses"], action.payload);

    case actionNameTypes.prefilSecAddrValType:
      return state.setIn(["secondaryAdvisor", "addresses"], action.payload);

    case actionNameTypes.changeAddressHandlerType:
      var obj = Object.keys(action.payload);
    
        return state.setIn([obj[0], "addresses"], action.payload[obj[0]]).setIn(["isDataChanged", "changed"], true).setIn([obj[0], "deletedAddress"],action.payload[obj[0]]["deletedAddress"]||state.getIn([obj[0], "deletedAddress"])); 
        
    case actionNameTypes.resetFormAddrType:
      var obj = Object.keys(action.payload);
      return state
        .setIn([obj[0], "addresses"], action.payload[obj[0]])
        .setIn(["isDataChanged", "changed"], true);

    case actionNameTypes.prefilPrimaryPhoneValType:
      return state.setIn(["primaryAdvisor", "phone"], action.payload);

    case actionNameTypes.prefilSecondaryPhoneValType:
      return state.setIn(["secondaryAdvisor", "phone"], action.payload);

    case actionNameTypes.changePhoneHandlerType:
      var obj = Object.keys(action.payload);
      return state
        .setIn([obj[0], "phone"], action.payload[obj[0]]).setIn(["isDataChanged", "changed"], true);

    case actionNameTypes.resetFormPhoneType:
      var obj = Object.keys(action.payload);
      return state.setIn([obj[0], "phone"], action.payload[obj[0]]);

    case actionNameTypes.clearSecAdvFormType:
      var obj = Object.keys(action.payload);      
      return state.setIn([obj[0], "info"], action.payload[obj[0]]);

    case actionNameTypes.prefilPrimaryValType:
      return state.setIn(["primaryAdvisor", "info"], action.payload);

    case actionNameTypes.prefilSecondaryValType:
      return state.setIn(["secondaryAdvisor", "info"], action.payload);

    case actionNameTypes.handleInfoChangeType:
      var obj = Object.keys(action.payload);
      return state
        .setIn(["secondaryAdvisor", "info", obj[0]], action.payload[obj[0]])
        .setIn(["isDataChanged", "changed"], true);

    case actionNameTypes.resetFormType:
      var obj = Object.keys(action.payload);
      return state.setIn([obj[0], "info"], action.payload[obj[0]]);

    case actionNameTypes.handleRadioChangePrimaryType:
      return state
        .setIn(
          ["primaryAdvisor", "info", "deliveryMethod"],
          action.payload.deliveryMethod
        )
        .setIn(["isDataChanged", "changed"], true);

    case actionNameTypes.handleRadioChangeSecondaryType:
      return state
        .setIn(
          ["secondaryAdvisor", "info", "deliveryMethod"],
          action.payload.deliveryMethod
        )
        .setIn(["isDataChanged", "changed"], true);

    case actionNameTypes.resetType:
      var obj = Object.keys(action.payload);
      return state.setIn([obj[0], "reset"], action.payload[obj[0]]);

    case actionNameTypes.addAdvBtnDisableType:
      return state.setIn(["primaryAdvisor", "disable"], action.payload.disable);

    case actionNameTypes.savePrimaryInfoType:
      var obj = Object.keys(action.payload);
      return state
        .setIn(["primaryAdvisor", "info", obj[0]], action.payload[obj[0]])
        .setIn(["isDataChanged", "changed"], true);

    case getUserEditDetailsType:
      let formattedData = apiDataFormatter(action.payload);
      
      return state
        .setIn(["primaryAdvisor", "addresses"], {
          addresses: DataFormatter(
            formattedData.advisors
              .filter(data => {
                if (data.primary == true) {
                  return data;
                }
              })
              .map(data => {
                return data.addresses;
              })[0],
            "addresses"
          )
        })
        .setIn(["submitEditAdvisorError"],{})
        .setIn(["primaryAdvisor", "role"], {
          role: formattedData.advisors
            .filter(data => {
              if (data.primary == true) {
                return data;
              }
            })
            .map(data => {
              return data.role;
            })[0]
        })
        .setIn(["secondaryAdvisor", "role"], {
          role:
            formattedData.advisors
              .filter(data => {
                if (data.primary == false) {
                  return data;
                }
              })
              .map(data => {
                return data.role;
              })[0] === undefined
              ? {
                  roleId: 0,
                  roleType: "Account Advisor - Full Access",
                  roleTypeId: 1,
                  name: null,
                  primary: null
                }
              : formattedData.advisors
                  .filter(data => {
                    if (data.primary == false) {
                      return data;
                    }
                  })
                  .map(data => {
                    return data.role;
                  })[0]
        })
        .setIn(["primaryAdvisor", "userId"], {
          userId: formattedData.advisors
            .filter(data => {
              if (data.primary == true) {
                return data;
              }
            })
            .map(data => {
              return data.userId;
            })[0]
        })
        .setIn(["secondaryAdvisor", "userId"], {
          userId:
            formattedData.advisors
              .filter(data => {
                if (data.primary == false) {
                  return data;
                }
              })
              .map(data => {
                return data.userId;
              })[0] === undefined
              ? formattedData.advisors
                  .filter(data => {
                    if (data.primary == true) {
                      return data;
                    }
                  })
                  .map(data => {
                    return data.userId;
                  })[0]
              : formattedData.advisors
                  .filter(data => {
                    if (data.primary == false) {
                      return data;
                    }
                  })
                  .map(data => {
                    return data.userId;
                  })[0]
        })
        .setIn(["editAdvisorAPIData", "data"], action.payload)
        .setIn(["secondaryAdvisor", "addresses"], {
          addresses:
            formattedData.advisors.filter(data => {
              if (data.primary == false) {
                return data;
              }
            }).length === 0
              ? [
                  {
                    addresstype: "",
                    line1: "",
                    line2: "",
                    line3: "",
                    state: "",
                    city: "",
                    zipcode: "",
                    country: "0",
                    key: 0,
                    primary: true
                  }
                ]
              : DataFormatter(
                  formattedData.advisors
                    .filter(data => {
                      if (data.primary == false) {
                        return data;
                      }
                    })
                    .map(data => {
                      return data.addresses;
                    })[0],
                  "addresses"
                )
        })
        .setIn(["primaryAdvisor", "email"], {
          email: DataFormatter(
            formattedData.advisors
              .filter(data => {
                if (data.primary == true) {
                  return data;
                }
              })
              .map(data => {
                return data.emails;
              })[0],
            "email"
          )
        })
        .setIn(["secondaryAdvisor", "email"], {
          email:
            formattedData.advisors.filter(data => {
              if (data.primary == false) {
                return data;
              }
            }).length === 0
              ? [
                  {
                    emailtype: "",
                    emailId: "",
                    key: 0,
                    primary: true
                  }
                ]
              : DataFormatter(
                  formattedData.advisors
                    .filter(data => {
                      if (data.primary == false) {
                        return data;
                      }
                    })
                    .map(data => {
                      return data.emails;
                    })[0],
                  "email"
                )
        })
        .setIn(["primaryAdvisor", "phone"], {
          phone: DataFormatter(
            formattedData.advisors
              .filter(data => {
                if (data.primary == true) {
                  return data;
                }
              })
              .map(data => {
                return data.phones;
              })[0],
            "phone"
          )
        })
        .setIn(["secondaryAdvisor", "phone"], {
          phone:
            formattedData.advisors.filter(data => {
              if (data.primary == false) {
                return data;
              }
            }).length === 0
              ? [
                  {
                    phonetype: "",
                    phonenumber: "",
                    key: 0,
                    primary: true
                  }
                ]
              : DataFormatter(
                  formattedData.advisors
                    .filter(data => {
                      if (data.primary == false) {
                        return data;
                      }
                    })
                    .map(data => {
                      return data.phones;
                    })[0],
                  "phone"
                )
        })
        .setIn(["primaryAdvisor", "info"], {
          title: formattedData.advisors[0].title,
          firstname: formattedData.advisors[0].firstname,
          middlename: formattedData.advisors[0].middlename,
          lastname: formattedData.advisors[0].lastname,
          suffix: formattedData.advisors[0].suffix,
          gender: formattedData.advisors[0].gender,
          dob: formattedData.advisors[0].dateOfBirthStr ? formattedData.advisors[0].dateOfBirthStr : formattedData.advisors[0].dob,
          // dateOfBirthStr: formattedData.advisors[0].dateOfBirthStr,
          ssn: formattedData.advisors[0].ssn,
          confirmSSN: formattedData.advisors[0].ssn,
          deliveryMethod: formattedData.advisors[0].deliveryMethod
        })
        .setIn(
          ["secondaryAdvisor", "info"],
          formattedData.advisors.length > 1
            ? {
                title: formattedData.advisors[1].title,
                firstname: formattedData.advisors[1].firstname,
                middlename: formattedData.advisors[1].middlename,
                lastname: formattedData.advisors[1].lastname,
                suffix: formattedData.advisors[1].suffix,
                gender: formattedData.advisors[1].gender,
                dob: formattedData.advisors[1].dateOfBirthStr ? formattedData.advisors[1].dateOfBirthStr : formattedData.advisors[1].dob,
                // dateOfBirthStr: formattedData.advisors[1].dateOfBirthStr,
                ssn: formattedData.advisors[1].ssn,
                confirmSSN: formattedData.advisors[1].ssn,
                deliveryMethod: formattedData.advisors[1].deliveryMethod,
                key: 0
              }
            : {
                title: "",
                firstname: "",
                lastname: "",
                middlename: "",
                suffix: "",
                gender: "",
                dob: "",
                key: 0,
                ssn: "",
                confirmSSN: "",
                deliveryMethod: "E-Delivery"
              }
        )
        .setIn(
          ["isSecondaryAdvisor", "isSecondaryAdvisor"],
          formattedData.advisors.length > 1
            ? { isSecondaryAdvisor: true }
            : null
        )
        .setIn(
          ["primaryAdvisor", "disable"],
          formattedData.advisors.length > 1 ? true : false
        )
        .setIn(["webAccessInfo", "userId"], formattedData.userId)
        .setIn(["primaryAdvisor", "relatedDonor"], {
          relatedDonor:
            formattedData.advisors.filter(data => {
              if (data.primary == "true") {
                return data;
              }
            }) === null
              ? DataFormatter(
                  formattedData.advisors
                    .filter(data => {
                      if (data.primary == "true") {
                        return data;
                      }
                    })
                    .map(data => {
                      return data.relatedDonor;
                    })[0],
                  "relatedDonor"
                )
              : []
        }).setIn(["primaryAdvisor", "deletedAddress"],[]).setIn(["secondaryAdvisor", "deletedAddress"],[])

    case actionNameTypes.updateDropDownValType:
        let data = action.payload;
        data.title.unshift({ value: "-1", desc: "--" });
        data.suffix.unshift({ value: "-1", desc: "--" });       
        return state.setIn(["dropdownValues", "data"], data);    

    case "GET_ZIPCODE1":
      if (action.payload.fetchPayload.stepnum == 2) {
        if (action.payload.response) {
          let countryData = "";
          if (action.payload.response.country == "US") {
            countryData = "United States";
          }
          let data = filterCountryDesc(
            countryData,
            state.getIn(["dropdownValues", "data", "countries"])
          );
          if (state.getIn(["legacyValues"])) {
            let index = 1;
            let successorAdvisor;
            if (
              action.payload.fetchPayload.contentKey == 0 ||
              action.payload.fetchPayload.contentKey == 1
            ) {
              successorAdvisor = "successorAdvisor";
            } else {
              successorAdvisor = "successionPlanGranteeOrg";
            }
            return state
              .setIn(
                [
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "city"
                ],
                action.payload.response.city
                  .toLowerCase()
                  .charAt(0)
                  .toUpperCase() +
                  action.payload.response.city.toLowerCase().slice(1)
              )
              .setIn(
                [
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "state"
                ],
                action.payload.response.state
              )
              .setIn(
                [
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "country"
                ],
                data[0].value
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: true
              });
          } else {
            return state
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "city"
                ],
                action.payload.response.city
                  .toLowerCase()
                  .charAt(0)
                  .toUpperCase() +
                  action.payload.response.city.toLowerCase().slice(1)
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "state"
                ],
                action.payload.response.state
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "country"
                ],
                data[0].value
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: true
              });
          }
        } else {
          if (state.getIn(["legacyValues"])) {
            let index;
            if (action.payload.fetchPayload.path == "primaryAdvisor") {
              index = 0;
            } else index = 1;
            let successorAdvisor;
            if (
              action.payload.fetchPayload.contentKey == 0 ||
              action.payload.fetchPayload.contentKey == 1
            ) {
              successorAdvisor = "successorAdvisor";
            } else {
              successorAdvisor = "successionPlanGranteeOrg";
            }
            return state
              .setIn(
                [
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "city"
                ],
                undefined
              )
              .setIn(
                [
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "state"
                ],
                undefined
              )
              .setIn(
                [
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "country"
                ],
                undefined
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: false
              });
          } else {
            return state
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "city"
                ],
                undefined
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "state"
                ],
                undefined
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyValues",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "country"
                ],
                undefined
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: false
              });
          }
        }
      } else {
        if (action.payload.response) {
          let countryData = "";
          if (action.payload.response.country == "US") {
            countryData = "United States";
          }
          let data = filterCountryDesc(
            countryData,
            state.getIn(["dropdownValues", "data", "countries"])
          );
          if (state.getIn(["tempJSON", "tempJSON", "tempJSON"])) {
            let index;
            if (action.payload.fetchPayload.path == "primaryAdvisor") {
              index = 0;
            } else index = 1;
            return state
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "city"
                ],
                action.payload.response.city
                  .toLowerCase()
                  .charAt(0)
                  .toUpperCase() +
                  action.payload.response.city.toLowerCase().slice(1)
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "state"
                ],
                action.payload.response.state
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "country"
                ],
                data[0].value
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: true
              })
              .setIn(["isDataChanged", "changed"], true);
          } else {
            return state
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "city"
                ],
                action.payload.response.city
                  .toLowerCase()
                  .charAt(0)
                  .toUpperCase() +
                  action.payload.response.city.toLowerCase().slice(1)
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "state"
                ],
                action.payload.response.state
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "country"
                ],
                data[0].value
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: true
              });
          }
        } else {
          if (state.getIn(["tempJSON", "tempJSON", "tempJSON"])) {
            let index;
            if (action.payload.fetchPayload.path == "primaryAdvisor") {
              index = 0;
            } else index = 1;
            return state
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "city"
                ],
                undefined
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "state"
                ],
                undefined
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "country"
                ],
                undefined
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: false
              });
          } else {
            return state
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "city"
                ],
                undefined
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "state"
                ],
                undefined
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "country"
                ],
                undefined
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: false
              });
          }
        }
      }

    case actionNameTypes.relatedContributorPrimaryType:
      return state.setIn(["primaryAdvisor", "relatedDonor"], action.payload);

    case "INCREMENT_DECREMENT_COUNT":
      return state.setIn(["advisorCount"], action.payload);

    case "INPUT_CHANGE":
      return state.setIn(["defaultFundName"], action.payload.fundName);

    case "HANDLE_ERROR":
      return state.setIn(["error"], action.payload);

      case actionNameTypes.savePercentageType: {
      const {legacyValue, contentKey} = action.payload;
      return state.setIn(["legacyValues", `${contentKey}`], {...legacyValue}).setIn(["hasChange"], false);
    }

    case actionNameTypes.resetLegacyFromApiType: {
      let initLegacyOpts = _.cloneDeep(initLegacyValues);
      initLegacyOpts[Constants.APPOINT_INDIVIDUAL].successorAdvisor = [{ ...baseSuccesorAdvisor, successionDetailId: `${getPrimaryAccount().userId}${Constants.APPOINT_INDIVIDUAL}1`, selected: true }];
      initLegacyOpts[Constants.CREATE_ACCOUNT].successorAdvisor = [{ ...baseSuccesorAdvisor, successionDetailId: `${getPrimaryAccount().userId}${Constants.CREATE_ACCOUNT}1`, selected: true }];
      initLegacyOpts[Constants.MULTI_CHARITY].successionPlanGranteeOrg = [{ ...baseSuccesorAdvisor, successionDetailId: `${getPrimaryAccount().userId}${Constants.MULTI_CHARITY}1`, selected: true }];
      return state
        .setIn(["advisorCount"], {
          count: 1,
          createCount: 1,
          charityCount: 1
        })
        .setIn(["showRemainingPercentage"], {
          showRemainingPercentage: false,
          showRemainingPercentage1: false,
          showRemainingPercentage2: false,
          showRemainingPercentage3: false,
          showRemainingPercentage4: false,
          showRemainingPercentage5: false
        })
        .setIn(["shouldClose"], {
          shouldClose: true
        })
        .setIn(["legacyValues"], initLegacyOpts)
        .setIn(
          ["legacyValues", "others"],
          state.getIn(["legacyValues", "others"])
        )
        .setIn(["legacyFormValid"], {
          multiCharity: true,
          appointInd: true,
          createAcc: true
        });
    }

      case actionNameTypes.saveSuccessorValuesType: {
      const contentKey = action.payload.key;
      const changedData = action.payload.successorInfo;
      let val = state.getIn(["legacyValues", `${contentKey}`]);
      if (contentKey === Constants.APPOINT_INDIVIDUAL || contentKey === Constants.CREATE_ACCOUNT) {
        val.successorAdvisor = changedData;
        val.hasChange = true;
      } else if (contentKey === Constants.MULTI_CHARITY) {
        val.successionPlanGranteeOrg = changedData;
        val.hasChange = true;
      }      
      return state.setIn(["legacyValues", `${contentKey}`], val).setIn(["hasChange"], false);
    }
    case actionNameTypes.selectSuccessionPlanType: {
      const contentKey = action.payload.key;
      let legacyValues = state.getIn(["legacyValues", `${contentKey}`]);
      legacyValues.selected = action.payload.selected;
      const detailId = `${getPrimaryAccount().userId}${contentKey}1`;

      if(legacyValues.optionId === 1 || legacyValues.optionId === 2) {
        if(legacyValues.successorAdvisor[0].hasOwnProperty('key')) {         
          legacyValues.successorAdvisor = [{ ...baseSuccesorAdvisor, selected: action.payload.selected }];    
        } else {
          legacyValues.successorAdvisor.push({ ...baseSuccesorAdvisor, selected: action.payload.selected });
        }

        if(action.payload.selected) {
          legacyValues.successorAdvisor[legacyValues.successorAdvisor.length - 1].successionDetailId = detailId;
        } else {
          legacyValues.successorAdvisor[legacyValues.successorAdvisor.length - 1].successionDetailId = null
        }
      }

      if(legacyValues.optionId === 4) {
        if(legacyValues.successionPlanGranteeOrg[0].hasOwnProperty('key')) {       
          legacyValues.successionPlanGranteeOrg = [{ ...baseSuccesorAdvisor, selected: action.payload.selected }];  
        } else {
          legacyValues.successionPlanGranteeOrg.push({ ...baseSuccesorAdvisor, selected: action.payload.selected });
        }

        if(action.payload.selected) {
          legacyValues.successionPlanGranteeOrg[legacyValues.successionPlanGranteeOrg.length - 1].successionDetailId = detailId;
        } else {
          legacyValues.successionPlanGranteeOrg[legacyValues.successionPlanGranteeOrg.length - 1].successionDetailId = null
        } 
      }
      return state.setIn(["legacyValues", `${contentKey}`], legacyValues);
    }
    case actionNameTypes.saveOptionDataType:
      return state.setIn(["hasChange"], action.payload);
    case actionNameTypes.errorVariableType:
      return state.setIn(["errorVariable"], action.payload);
      case actionNameTypes.addSuccessorType: {
      var {contentKey, successors, successionDetailId} = action.payload;           
      let updatedSucc = [...successors];
      if (contentKey === Constants.APPOINT_INDIVIDUAL || contentKey === Constants.CREATE_ACCOUNT) {      
        updatedSucc.push({ ...baseSuccesorAdvisor, successionDetailId, selected: true });        
        return state
        .setIn(["legacyValues", `${contentKey}`, "successorAdvisor"], updatedSucc);
      } else if (contentKey === Constants.MULTI_CHARITY) {
        updatedSucc.push({ ...baseSuccesorAdvisor, successionDetailId, selected: true });        
        return state
        .setIn(["legacyValues", `${contentKey}`, "successionPlanGranteeOrg"], updatedSucc);
      }
      return state;
    }
   
    case actionNameTypes.updateStepNameType:
      return state.set("activePageStepName", action.payload);

    case actionNameTypes.resetLegacyType:
      return state.setIn(["resetLegacy"], action.payload);

    case actionNameTypes.showRemainingPercentageType:
      return state
        .setIn(
          [
            "showRemainingPercentage",
            `showRemainingPercentage${action.payload.key}`
          ],
          action.payload.value
        )
        .setIn(
          ["showRemainingPercentage", "showRemainingPercentage"],
          action.payload.showRemainingPercentage
        );

    case "SHOW_MAIN_PERCENTAGE":
      return state.setIn(
        ["showRemainingPercentage", "showRemainingPercentage"],
        action.payload.showRemainingPercentage
      );

    case actionNameTypes.removeValuesType: {
      let legacyValues = state.getIn(["legacyValues", `${action.payload}`]);
      legacyValues.selected = false;
      legacyValues.assignedPercentage = 0;
      if(action.payload === Constants.APPOINT_INDIVIDUAL || action.payload === Constants.CREATE_ACCOUNT) {
        legacyValues.successorAdvisor = legacyValues.successorAdvisor.map((adv) => {
          adv.selected = false;
          return adv;
        })
      }

      if(action.payload === Constants.MULTI_CHARITY) {
        legacyValues.successionPlanGranteeOrg = legacyValues.successionPlanGranteeOrg.map((chr) => {
          chr.charityAllocPercent = "0";
          chr.selected = false;
          return chr;
        })
      }      
      return state.setIn(["legacyValues", `${action.payload}`], legacyValues)
      .setIn(["legacyFormValid", `${action.payload}`],true);
    }

    case actionNameTypes.shouldCloseType:
      return state.setIn(["shouldClose", "shouldClose"], action.payload);

    case actionNameTypes.isSecAdvType:
      return state.setIn(
        ["isSecondaryAdvisor", "isSecondaryAdvisor"],
        action.payload
      );

    case "SHOULD_SHOW_MORE":
      return state.setIn(["showMore", "showMore"], action.payload);

    case "STORE_FINAL_JSON":
      return state.setIn(["finalJSON"], action.payload);

    case actionNameTypes.jsonTempType:
      return state.setIn(["tempJSON", "tempJSON"], action.payload);

    case actionNameTypes.emptyZipType:
      return state.setIn(["shouldEmptyZip", "shouldEmptyZip"], action.payload);

    /******************************* My Reducers ******************************/

    case actionNameTypes.displaySuccessionValSuccessType:
      return state
        .setIn(["hasChange"], false)
        .setIn(["successionPlan", "data"], action.payload)
        .setIn(["successionPlan", "isLoading"], false);

    case actionNameTypes.displaySuccessionValLoaderType:
      return state.setIn(["successionPlan", "isLoading"], true);

    case "GET_DROPDOWN_VALUES_SUCCESSS":
      return state
        .setIn(["dropdownValues", "data"], action.payload)
        .setIn(["titleValues"], title)
        .setIn(["dropdownValues", "isLoading"], false);

    case actionNameTypes.fetchDropDownLoaderValType:
      return state.setIn(["dropdownValues", "isLoading"], true);

    case actionNameTypes.fetchRelationDropDownSuccessType:
      return state
        .setIn(["relationshipValues", "data"], action.payload)
        .setIn(["relationshipValues", "isLoading"], false);

    case actionNameTypes.fetchRelationDropDownLoaderValType:
      return state.setIn(["relationshipValues", "isLoading"], true);

      case actionNameTypes.legacyValuesFromApiType: {
      let mergedVal = _.cloneDeep(initLegacyValues);      
      for (let option of Object.keys(mergedVal)) {        
        const apiData = action.payload
                        .filter(data => data.optionId === mergedVal[option].optionId)
                        .map(item => {
                          if(item.optionId === 1 || item.optionId === 2) {
                            if(!item.successorAdvisor) {
                              if(item.selected) {
                                const detailsId = `${getPrimaryAccount().userId}${ item.optionId === 1 ? Constants.APPOINT_INDIVIDUAL: Constants.CREATE_ACCOUNT }1`;
                                item.successorAdvisor = [{ ...baseSuccesorAdvisor, successionDetailId: detailsId, selected: item.selected}];
                              } else {
                                item.successorAdvisor = [{ ...baseSuccesorAdvisor, successionDetailId: null, selected: false }];
                              }
                            }                            
                          } else if(item.optionId === 4) {
                            if(!item.successionPlanGranteeOrg) {
                              if(item.selected) {
                                const detailsId = `${getPrimaryAccount().userId}${Constants.MULTI_CHARITY}1`;
                                item.successionPlanGranteeOrg = [{ ...baseSuccesorAdvisor, successionDetailId: detailsId, selected: item.selected}];
                              } else {
                                item.successionPlanGranteeOrg = [{ ...baseSuccesorAdvisor, successionDetailId: null, selected: false }];
                              }                              
                            }
                          }
                          return item;
                        })
        if (apiData.length) {
          mergedVal[option] = {...mergedVal[option], ...apiData[0]};
        }
      }         
      return state.setIn(["legacyValues"], mergedVal);                  
    }
    case "UPDATE_LEGACY_VALUES_SUCCESSS":
      return state.setIn(["updateSuccession"], action.payload);
    case actionNameTypes.espSubmitLoader:
        return state.setIn(["apiIndicator"], true);
    case actionNameTypes.esphideSubmitLoader:
        return state.setIn(["apiIndicator"], false);
    case "POST_ACCOUNT_ADVISOR_SUCCESS":     
      return state.setIn(["submitEditAdvisorError"],{isError:false});
    case actionNameTypes.doesOthersExistType:
      return state.setIn(["othersExist"], action.payload);
    case actionNameTypes.accessKeySuccessType:
      return state.setIn(["accessKeyData"], action.payload);

    case actionNameTypes.tableDataUpdateSuccType:
      return state
        .setIn(["defaultData"], action.payload)
        .setIn(["toUpdate"], !state.getIn(["toUpdate"]));

    /**************EDIT PROFILE***************** */
    case "POST_PROFILE_SUCCESS":
      return state.setIn(["postSuccess"], true);

    case "POST_PROFILE_ERROR":
      return state.setIn(["postSuccess"], false);
    case actionNameTypes.profileJsonTempType:
      return state.setIn(["tempJSON", "tempJSON"], action.payload);
    case "POLICIES_SUCCESS":
      return state.setIn(["policies"], action.payload);

    case "ENDOWED_SUCCESS":
      return state.setIn(["endowed"], action.payload);
    case actionNameTypes.countriesListType:
      return state.setIn(["countries"], action.payload.countries);
    case "DEFAULT_UPDATE":
      let changeDefvalue = action.payload + 1
      return state.setIn(["changeDefault"], changeDefvalue)
    case "POST_ACCOUNT_ADVISOR_ERROR":
      return state.setIn(["submitEditAdvisorError"],{isError:true});
    case actionNameTypes.clearEditProfileErrorType:
        return state
          .setIn(["submitEditAdvisorError"],{ isError: false })
          .setIn(["postSuccess"], null)
          .setIn(["isDataChanged"], { changed: false });

 /****************************UPDATE USER ID*********************** */
    case actionNameTypes.userIdSuccessType:
    return state.setIn(["updateUserIdData"], action.payload);

    case actionNameTypes.userIdExistsType:
    return state.setIn(["useridExists"], action.payload);

    case actionNameTypes.userIndExistType:
    return state.setIn(["useridExistsBefore"], action.payload);
    
    case actionNameTypes.clearErrMessageType:
      return state.setIn(["useridExists"], null)
      .setIn(["useridExistsBefore"], null);

    case actionNameTypes.clearUpdUserIdType:    
        return state
        .setIn(["updateUserIdData"], action.payload)
        .setIn(["correctUseridResponseCount"], 0)
        .setIn(["incorrectUseridResponseCount"], 0);

    case actionNameTypes.correctResUserType:
      let correctUseridCount = action.payload + 1;      
      return state.setIn(["correctUseridResponseCount"], correctUseridCount)
              .setIn(["incorrectUseridResponseCount"], 0);
  
  case actionNameTypes.inCorrectResUserType:
      let incorrectUseridCount = action.payload + 1      
      return state.setIn(["incorrectUseridResponseCount"], incorrectUseridCount); 

    /****************************UPDATE MFA EMAIL ID*********************** */
    case actionNameTypes.mfaEmailSuccessType:
    return state.setIn(["updatemfaEmailData"], true);

    case actionNameTypes.mfaEmailFailureType:
    return state.setIn(["updatemfaEmailFailed"], true);

    case actionNameTypes.mfaEmailExistsType:
    return state.setIn(["mfaEmailExists"], action.payload);

    case actionNameTypes.mfaEmailExistType:
    return state.setIn(["mfaEmailExistsBefore"], action.payload);
    
    case actionNameTypes.clearmfaEmailErrMessageType:
      return state.setIn(["mfaEmailExists"], null)
      .setIn(["mfaEmailExistsBefore"], null);

    case actionNameTypes.clearUpdmfaEmailType:    
        return state
        .setIn(["updatemfaEmailData"], action.payload)
        .setIn(["correctmfaEmailResponseCount"], 0)
        .setIn(["incorrectmfaEmailResponseCount"], 0);

    case actionNameTypes.correctResmfaEmailType:
      let correctmfaEmailCount = action.payload + 1;      
      return state.setIn(["correctmfaEmailResponseCount"], correctmfaEmailCount)
              .setIn(["incorrectmfaEmailResponseCount"], 0);
  
  case actionNameTypes.inCorrectResmfaEmailType:
      let incorrectmfaEmailCount = action.payload + 1      
      return state.setIn(["incorrectmfaEmailResponseCount"], incorrectmfaEmailCount);  
  
  case actionNameTypes.updatedmfaEmailApiResType:
                return state.setIn(["mfaEmailapiFlag"], true);

  /****************************Resend Email *********************** */
  case actionNameTypes.resendEmailSuccessType:
    return state.setIn(["updateresendEmailData"], true);

    case actionNameTypes.resendEmailFailureType:
    return state.setIn(["updateresendEmailFailed"], true);

    case actionNameTypes.resendEmailClearFlagType:
    return state.setIn(["updateresendEmailFailed"], false)
                . setIn(["updateresendEmailData"], false);

    /**************************** Change MFA phone number *********************** */
  case actionNameTypes.changeMFAPhNoSuccessType:
    return state.setIn(["changeMFAPhNoData"], true);

    case actionNameTypes.changeMFAPhNoFailureType:
    return state.setIn(["changeMFAPhNoFailed"], true);

    case actionNameTypes.changeMFAPhNoClearFlagType:
    return state.setIn(["changeMFAPhNoFailed"], false)
                .setIn(["changeMFAPhNoData"], false);

    case actionNameTypes.refreshMFAPhNoComType:
    return state.setIn(["profileData","data", "webAccess", "mfaPhoneNo"], '')
                .setIn(["changeMFAPhNoData"], undefined);
    
    /**Invite interest parties reducers */
    case actionNameTypes.postInviteSuccessType:
    return state
          .setIn(["postInviteSuccess"], true);  

    case actionNameTypes.postInviteErrorType:
      return state.setIn(["postInviteSuccess"], false)
      .setIn(["isPostInviteError"], true);

    case actionNameTypes.clearInvitePartyType:
      return state.setIn(["postInviteSuccess"], false); 
      
    case actionNameTypes.clearInvitePartyTypeError:
        return state.setIn(["isPostInviteError"], false); 
    
    /**Invite interest parties reducers */

    case actionNameTypes.addSecondaryAdvSuccType:
        return state
        .setIn(["secondaryAdvisorRes", "error"], null)
        .setIn(["secondaryAdvisorRes", "success"], action.payload); 
        
    case actionNameTypes.addSecondaryAdvFailureType:
        return state
        .setIn(["secondaryAdvisorRes", "error"], action.error)
        .setIn(["secondaryAdvisorRes", "success"], null);
    case actionNameTypes.clearSecAdvType:
        return state
        .setIn(["secondaryAdvisorRes", "error"], null)
        .setIn(["secondaryAdvisorRes", "success"], null);
        
    case actionNameTypes.updatedUserIdApiResType:
    return state.setIn(["apiFlag"], true);
    case actionNameTypes.myAccMandatoryType:
      return state.setIn(['myAccountMandatoryMissingFlag'], action.payload)
    case actionNameTypes.udpateValidLegacyFormType:
      return state.setIn(["legacyFormValid", `${action.payload}`],false)
    default:
      return state;
  }
};

export default myAccount;
